// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"f2954d55","207":"7d620804","363":"12cbcf60","762":"51611687","787":"18291070"}[chunkId] + ".chunk.js";
};